import React from 'react';

import Article from '../DataDisplay/Article';
import {WarningIcon} from '../Icons';
import ContentWrapper from '../Layout/ContentWrapper';
import PopupHeaderIcon from './components/PopupHeaderIcon/PopupHeaderIcon';
import PopupFullPage from './PopupFullPage';

const PopupWarning = (props) => {
    const {alt} = props;

    return (
        <PopupFullPage {...props}>
            <ContentWrapper className='py-10 lg:pt-[88px]'>
                <Article icon={<PopupHeaderIcon ariaLabel={alt} icon={WarningIcon} />} {...props} />
            </ContentWrapper>
        </PopupFullPage>
    );
};

export default PopupWarning;
